import messages from '../locales/es_ES.json';

const saLang = {
  messages: {
    ...messages
  },
  locale: 'es',
};
export default saLang;
